
import Vue from "vue";
import Vuex from "vuex";
import user from './module/user'
import billing from './module/billing'
import dict from './module/dict'
import address from './module/address'
import fabric from './module/fabric'
import cart from './module/cart'
import logistics from './module/logistics'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fullWidth:0,//实时屏幕宽度
  },
  mutations: {},
  actions: {},
  modules: {
    user,
    billing,
    dict,
    address,
    fabric,
    cart,
    logistics
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js